'use client';

import { useEffect } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

export default function DashboardError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[Dashboard Error]', error);
  }, [error]);

  return (
    <div className="min-h-[calc(100vh-57px)] flex items-center justify-center bg-cs-surface-page">
      <div className="text-center space-y-4 px-8">
        <div className="w-14 h-14 mx-auto rounded-xl bg-cs-error-bg border border-cs-error-500/30 flex items-center justify-center">
          <AlertTriangle className="w-7 h-7 text-cs-error-400" aria-hidden="true" />
        </div>
        <h1 className="text-xl font-semibold text-cs-text-primary">Something went wrong</h1>
        <p className="text-sm text-cs-text-muted max-w-sm">
          An unexpected error occurred in this module.
        </p>
        {error.digest && (
          <p className="text-xs font-mono text-cs-text-disabled">Error ID: {error.digest}</p>
        )}
        <button
          onClick={reset}
          className="inline-flex items-center gap-2 mt-4 px-4 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium transition-colors"
        >
          <RefreshCw className="w-4 h-4" aria-hidden="true" />
          Try again
        </button>
      </div>
    </div>
  );
}
